export const CyMultiChangeToolbar = {
  EmptySelection: "EmptySelection",
  CopyMovePlaylists: "CopyMovePlaylists",
  DeletePlaylists: "DeletePlaylists",
  Toolbar: "Toolbar",
} as const;
